import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { usePageActionsStore } from '@/store/pageActionsStore';

interface PageActions {
  primary?: () => ReactNode;
  secondary?: () => ReactNode;
}

export function usePageActions(actions: PageActions) {
  const setActions = usePageActionsStore((state) => state.setActions);
  const clearActions = usePageActionsStore((state) => state.clearActions);

  useEffect(() => {
    setActions(actions.primary ?? null, actions.secondary ?? null);

    return () => {
      clearActions();
    };
  }, [actions.primary, actions.secondary, setActions, clearActions]);
}
